import React from 'react';

const SvgMinimizeOutlined = (props) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clip-path="url(#clip0_21754_12986)">
            <path d="M3 14.1655V15.6655H7.9395L1.5 22.102L2.5605 23.1655L9 16.726V21.6655H10.5V14.1655H3Z" fill="#60636B"/>
            <path d="M22.5 3.22753L21.444 2.16553L15 8.60503V3.66553H13.5V11.1655H21V9.66553H16.0605L22.5 3.22753Z" fill="#60636B"/>
        </g>
        <defs>
            <clipPath id="clip0_21754_12986">
                <rect width="24" height="24" fill="white" transform="translate(0 0.665527)"/>
            </clipPath>
        </defs>
    </svg>
);

export default SvgMinimizeOutlined;
